import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResultType } from '../../../../models/enums/result-type.enum';
import { ManagementApiService } from '../../../../services';
import { CalculationResult } from '../../models/calculationModels/calculation-result';
import { UserMatrixModel } from '../../models/user-matrix-model';
import { UserMatrixRowModel } from '../../models/user-matrix-row-model';
import { SuccessDialogComponent } from 'src/app/shared/info-dialogs/success-dialog/success-dialog.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { Subject, takeUntil } from 'rxjs';
@Component({
    selector: 'app-matrix-add-or-create',
    templateUrl: './matrix-add-or-create.component.html',
    styleUrls: ['./matrix-add-or-create.component.scss'],
})
export class MatrixAddOrCreateComponent implements OnInit {
    @Input() calcOutput: CalculationResult;
    destroy$ = new Subject();

    closeResult: string;
    matrixFormGroup: UntypedFormGroup;
    result: ResultType = ResultType.Error;
    userMatrixResponse: UserMatrixModel;
    isAddToMatrix: boolean = false;

    constructor(
        private fb: UntypedFormBuilder,
        private modalService: NgbModal,
        private mgmtApi: ManagementApiService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private userUtilityService: UserUtilityService
    ) {}

    async ngOnInit(): Promise<void> {
        this.matrixFormGroup = this.fb.group({
            matrix: ['', Validators.required],
            matrixNewName: [''],
            jointId: [''],
        });
        this.matrixFormGroup
            .get('matrix')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => this.setValidators(value));
        // * checking access
        this.isAddToMatrix = await this.userUtilityService.checkUserPermissionDataAndRoute('matrix', userActions.Create);
    }

    setValidators(value: any): void {
        if (value == 'New') {
            this.matrixFormGroup.get('matrixNewName').setValidators(Validators.required);
        } else {
            this.matrixFormGroup.get('matrixNewName').clearValidators();
        }
        this.matrixFormGroup.get('matrixNewName').updateValueAndValidity();
    }

    open(content) {
        this.matrixFormGroup.reset();
        this.matrixFormGroup.updateValueAndValidity();
        this.modalService
            .open(content, {
                ariaLabelledBy: 'modal-basic-title',
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
            })
            .result.then(
                (result) => {
                    this.closeResult = `Closed with: ${result}`;
                },
                (reason) => {
                    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
                }
            );
    }

    btnAddMatrixClicked() {
        if (this.matrixFormGroup.valid) {
            let userMatrix = new UserMatrixModel();
            if (this.matrixFormGroup.get('matrix').value === 'New') {
                userMatrix.name = this.matrixFormGroup.get('matrixNewName').value;
                userMatrix.usage = 1;

                let userMatrixRowModel = new UserMatrixRowModel();
                userMatrixRowModel.jointID = this.matrixFormGroup.get('jointId').value;
                userMatrixRowModel.calculation = JSON.stringify(this.calcOutput);
                userMatrix.userMatrixRows = [userMatrixRowModel];
                this.createMatrix(userMatrix);
            } else {
                let userMatrixRowModel = new UserMatrixRowModel();
                userMatrixRowModel.userMatrixId = this.matrixFormGroup.get('matrix').value;
                userMatrixRowModel.jointID = this.matrixFormGroup.get('jointId').value;
                userMatrixRowModel.calculation = JSON.stringify(this.calcOutput);
                this.createMatrixRow(userMatrixRowModel);
            }
            this.modalService.dismissAll();
            this.matrixFormGroup.reset();
        }
    }

    async createMatrix(userMatrix: UserMatrixModel) {
        this.ngxUiLoaderService.start();
        this.mgmtApi
            .createMatrix(userMatrix)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (result) => {
                    this.ngxUiLoaderService.stop();
                    if (result.success === true) {
                        let dialogRef = this.modalService.open(SuccessDialogComponent, {
                            size: 'sm',
                        });
                        dialogRef.componentInstance.message = 'New matrix is added Sucessfully!';
                    } else {
                        this.userUtilityService.errorModelPopup(result.message);
                    }
                },
                (err) => {
                    this.ngxUiLoaderService.stop();
                }
            );
    }

    async createMatrixRow(userMatrixRowModel: UserMatrixRowModel) {
        this.ngxUiLoaderService.start();
        await this.mgmtApi
            .createMatrixRow(userMatrixRowModel)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (res) => {
                    this.ngxUiLoaderService.stop();
                    if (res.success === true) {
                        let dialogRef = this.modalService.open(SuccessDialogComponent, {
                            size: 'sm',
                        });
                        dialogRef.componentInstance.message = 'Matrix Row is added Sucessfully!';
                    } else {
                        this.userUtilityService.errorModelPopup(res.message);
                    }
                },
                (err) => {
                    this.ngxUiLoaderService.stop();
                }
            );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }
}
